module.exports = __webpack_public_path__ + "41d1ea14e899aa45e49176fa66187786.svg";